<template>
  <div class="activity-space">
    <div class="news-banner">
      <img :src="commonbg" width="100%" alt="">
    </div>
    <div class="activity-body">
      <div>
        <h3>联盟活动</h3>
        <el-divider></el-divider>
      </div>
      <div class="activity-part">
        <div class="doc-module-item" v-for="(item,index) in activityList" :key="index">
          <div class="doc-module-context">
            <el-row>
              <el-col :span="6">
                <div class="doc-module-img" @click="seeDocInfo(item.newsId)">
                  <img :src="item.newsMainImg" width="220" height="155" alt="">
                </div>
              </el-col>
              <el-col :span="18">
                <div class="doc-module-text">
                  <h3 class="highLight" @click="seeDocInfo(item.newsId)">{{item.newsTitle}}</h3>
                  <el-row>
                    <el-col :span='4'><span>时间：{{item.newsDate}}</span></el-col>
                    <el-col :span='8'><span>作者：{{item.newsCreateUserName}}</span></el-col>
                  </el-row>
                  <div>{{item.newsSummary}}</div>
                  <!-- <el-button type="text" class="know_module_more" @click="seeDocInfo(item.newsId)">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="hr-type">
            <el-divider></el-divider>
          </div>
        </div>
        <div class="news_page">
          <el-pagination :page-size="pageSize" layout="prev, pager, next" :total="totalPage" @current-change="turnPage" background class="pager_style">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sysNewsData } from '@/api/frontApi/common';
export default {
  data() {
    return {
      activeName: 'second',
      activityList: [],
      whichActivity: null,
      pageSize: 5,
      pageNo: 1,
      totalPage: 1
    };
  },
  computed: {
    commonbg() {
      return this.$store.state.commonbg;
    },
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  created() {
    this.initActivityList();
  },
  methods: {
    initActivityList() {
      sysNewsData({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        newsType: 5
      }).then(res => {
        this.activityList = [];
        let tempLen = res.data.list.length;
        for (let q = 0; q < tempLen; q++) {
          if (res.data.list[q].newsMainImg) {
            continue;
          } else {
            res.data.list[q].newsMainImg = this.defaultImg;
          }
        }
        this.activityList = res.data.list;
        this.totalPage = res.data.totalCount;
      });
    },
    seeDocInfo(infoId) {
      this.$router.push({
        name: 'activityInfo',
        params: {
          infoId: infoId
        }
      });
    },
    turnPage(val) {
      this.pageNo = val;
      this.initActivityList();
    }
  }
};
</script>
<style scoped>
.news-banner {
  width: 100%;
  margin-bottom: 20px;
}
.activity-space {
  width: 100%;
  min-height: 600px;
}
.activity-body {
  width: 65%;
  margin-left: 17.5%;
}
.activity-part {
  width: 100%;
  overflow: hidden;
  padding-left: 1%;
  min-width: 969px;
}
.current-part {
  float: left;
  width: 65%;
}
.his-part {
  float: left;
  width: 27%;
  margin-left: 5%;
}
.find-part {
  margin-bottom: 15px;
}
.his-item {
  overflow: hidden;
  margin-bottom: 5px;
  /* border: 1px solid red; */
  height: 90px;
  padding: 2px 0;
}
.his-img {
  float: left;
  cursor: pointer;
}
.his-text {
  float: left;
  margin-left: 10px;
}
.his-text-subs {
  margin-top: 10px;
}
.pager_style {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/activity/activity.vue